import React, { useContext } from "react";
import { ThemeContext } from "../../../../../context/theme-context";

export const WrapperSections = ({ children }) => {
  const { customTheme, setDataTheme, setUserAction } = useContext(ThemeContext);

  const handleChangeColor = (path, value) => {
    setUserAction(true);
    setDataTheme(path, value);
  };

  const handleSelect = (path, evt) => {
    setUserAction(true);
    setDataTheme(path, evt?.target?.value);
  };

  return React.Children.map(children, (child) => {
    return React.cloneElement(child, {
      customTheme,
      handleChangeColor,
      handleSelect,
    });
  });
};
